import { API_PATHS } from "../constants/api-paths";
import { logErrorToNewRelic } from "../utils/logging";
import { type IResponse, encryptedRequest } from "../core/api.client";
interface ITfInsertApiRequest {
  id?: string;
  mobileNo: string;
  journeyName: string; // icors or default
  journeyType?: string;
  prodName: string;
  custType: string;
  appId?: string;
  actualLoanAmt?: string;
  tenureInMon?: string;
  roi?: string;
  emiAmt?: string;
  offerId?: string;
  offerAmt?: string;
  processType?: string;
  saveForLaterFlag?: boolean;
}
interface ITfInsertApiResponse {
  id: string;
  eventCode: string;
  journeyName: string;
}
export async function postTFInsertApi(
  requestBody: ITfInsertApiRequest
): Promise<IResponse<ITfInsertApiResponse>> {
  try {
    const response = await encryptedRequest<ITfInsertApiResponse, ITfInsertApiRequest>({
      method: "POST",
      url: API_PATHS.tfInsert,
      data: requestBody,
    });
    if (response.statusCode !== 90) {
      throw new Error(response.message);
    }
    return response;
  } catch (error) {
    logErrorToNewRelic(error as string, {
      errorType: "Error in TF insert",
    });
    throw error;
  }
}
